module.exports = __webpack_public_path__ + "static/media/airblitz-1.ff90ed9e.jpg";